import * as tslib_1 from "tslib";
import getViewFilterDisplay from '../helpers/getViewFilterDisplay';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { observer } from 'mobx-react';
import { selectFilter } from 'owa-mail-filter-actions';
import { resetFocus } from 'owa-mail-focus-manager';
import { MailFilterContextMenu } from 'owa-mail-list-filter-view';
import { getSelectedTableView, getViewFilterForTable, listViewStore } from 'owa-mail-list-store';
import strings from 'owa-strings/owa-mail-strings';
import * as React from 'react';
import { filterViewStore, hideFilterDropDownContextMenu, showFilterDropDownContextMenu, } from 'owa-mail-list-filter-store';
import { AriaRoles, generateDomPropertiesForAria } from 'owa-accessibility';
var classNames = require('classnames/bind');
var styles = require('./MailListFilter.scss');
var MailListFilter = /** @class */ (function (_super) {
    tslib_1.__extends(MailListFilter, _super);
    function MailListFilter(props) {
        var _this = _super.call(this, props) || this;
        _this.onFilterClick = function (evt) {
            evt.stopPropagation();
            _this.onSelectFilter();
        };
        /**
         * Called when user presses keyboard on the filter dropdown title in listview
         */
        _this.onKeyDownOnFilter = function (ev) {
            switch (ev.keyCode) {
                case 13 /* Enter */:
                case 32 /* Space */:
                    ev.stopPropagation();
                    ev.preventDefault();
                    _this.onSelectFilter();
                    break;
            }
        };
        return _this;
    }
    MailListFilter.prototype.onSelectFilter = function () {
        if (getViewFilterForTable(getSelectedTableView()) == 'All') {
            showFilterDropDownContextMenu();
        }
        else {
            // Dismiss the filter if the LV is already filtered
            selectFilter('All', this.props.filterMenuSource);
            // Reset focus when the filter is closing and changing to "All"
            resetFocus();
        }
    };
    MailListFilter.prototype.dismissContextMenu = function () {
        hideFilterDropDownContextMenu();
        // Reset focus when filter context menu is dismissed
        resetFocus();
    };
    MailListFilter.prototype.getSelectedFilterText = function (currentSelectedFilter) {
        if (currentSelectedFilter == 'All') {
            return strings.mailFilter;
        }
        return getViewFilterDisplay(currentSelectedFilter);
    };
    MailListFilter.prototype.render = function () {
        var _this = this;
        var currentSelectedFilter = getViewFilterForTable(listViewStore.tableViews.get(this.props.tableViewId));
        var isAllFilterSelected = currentSelectedFilter == 'All';
        var containerClassNames = classNames(this.props.containerClassName, styles.filter);
        var dropDownIconClassNames = classNames(styles.icon, !isAllFilterSelected && styles.cancelIcon);
        var ariaProps = {
            role: AriaRoles.button,
        };
        return (React.createElement("div", tslib_1.__assign({ ref: function (ref) { return (_this.container = ref); }, className: containerClassNames, onClick: this.onFilterClick, onKeyDown: this.onKeyDownOnFilter }, generateDomPropertiesForAria(ariaProps), { tabIndex: 0 }),
            React.createElement("span", { className: styles.filterText }, this.getSelectedFilterText(currentSelectedFilter)),
            React.createElement(Icon, { className: dropDownIconClassNames, iconName: isAllFilterSelected ? "ChevronDownMed" /* ChevronDownMed */ : "Cancel" /* Cancel */ }),
            filterViewStore.filterContextMenuDisplayState && (React.createElement(MailFilterContextMenu, { currentViewFilter: currentSelectedFilter, supportedViewFilters: this.props.supportedViewFilters, dismissContextMenu: this.dismissContextMenu, contextMenuTargetElement: this.container, filterMenuSource: this.props.filterMenuSource, tableViewId: this.props.tableViewId }))));
    };
    MailListFilter = tslib_1.__decorate([
        observer
    ], MailListFilter);
    return MailListFilter;
}(React.Component));
export default MailListFilter;
//# sourceMappingURL=MailListFilter.js.map